"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var IconButton_1 = require("../../../../atoms/IconButton/IconButton");
var EditorToolbarIcon_logic_1 = require("./EditorToolbarIcon.logic");
var EditorToolbarIcon = function (_a) {
    var onMouseDown = _a.onMouseDown, isActive = _a.isActive, icon = _a.icon, tooltip = _a.tooltip;
    var _b = (0, EditorToolbarIcon_logic_1.useEditorToolbarIcon)({ onMouseDown: onMouseDown }), onMouseDownWrapped = _b.onMouseDownWrapped, classes = _b.classes;
    return ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { className: classes.root, icon: icon, isActive: isActive, onMouseDown: onMouseDownWrapped, tooltip: tooltip }));
};
exports.default = EditorToolbarIcon;
